
import { Component, Mixins } from "vue-property-decorator";
import ProductionsListingMixin from "./mixins/production-listing.mixin";
import PazTooltipButton from "@pazion/pazion-core/src/components/controls/PazTooltipButton.vue";
import PazRefreshButton from "@pazion/pazion-core/src/components/controls/PazRefreshButton.vue";
import PazToast from "@pazion/pazion-core/src/components/utils/PazToast.vue";
import PazMenuDatePicker from "@pazion/pazion-core/src/components/input/PazMenuDatepicker.vue";
import ProductionDetails from "./ProductionDetails.vue";
import ProductionFilterPanel from "./parts/ProductionFilterPanel.vue";
import PermissionService from "@pazion/pazion-core/src/services/permission-service";
import dayjs from "dayjs";
import PazOrderProductionDialog from "@pazion/pazion-catalog/src/components/dialog/pazOrderProductionDialog.vue";
import {IOrder} from "@pazion/pazion-catalog/src/models/order";
import {fetchOrderDocuments} from "@pazion/pazion-core/src/services/dossier-service";
import {getOrderDetails} from "@pazion/pazion-catalog/src/services/catalog-service";
import {IproductionCutInstance} from "@pazion/pazion-catalog/src/models/production.model";

@Component({
  components: {
    PazOrderProductionDialog,
    PazTooltipButton,
    PazRefreshButton,
    PazToast,
    PazMenuDatePicker,
    ProductionDetails,
    ProductionFilterPanel,
  },
})
export default class ProductionsListingPage extends Mixins(
  ProductionsListingMixin,
  PermissionService
) {
  public modeSwitcher: string = "single";
  public detailsProduction = null;
  public selectedOrder: IOrder|null= null;
  public selectedOrderId: number|null= null;
  public showOrderProductDialog:boolean = false;
  private defaultRequestParams = { expand: "production" };

  async showProductionDetails(item: any, popup:boolean = true) {
    if(popup && this.modeSwitcher == 'single'){
      this.selectedOrderId = item.orderLine.order;
      this.selectedOrder = await getOrderDetails(this.selectedOrderId, true);
      this.selectedOrder.production = 1;
      this.showOrderProductDialog = true;
      return;
    }
    this.detailsProduction = item;

    this.$router
      .push({ name: "production_details", params: { sku: item.sku } })
      .catch(() => {});
  }

  customSort(items: any[], index: string[], isDescending: boolean[]){


    if(index.length >= 1 && items && items.length){
      const sortIndex = index.length -1;
      let sortKey = index[sortIndex];
      if(sortKey == "productsku"){
        sortKey = 'sku';
      }
      const sortDirection = isDescending[sortIndex];
      if(['items', 'sheets','surface','quantity','production'].includes(sortKey)) {
        items.sort((a, b) => {
          if(sortDirection){
            return parseFloat(b[sortKey] ?? '') - parseFloat(a[sortKey] ?? '');
          }
          return parseFloat(a[sortKey] ?? '') - parseFloat(b[sortKey] ?? '');

        })
      }
      else{
        items.sort((a, b) => {
          if(sortDirection){
            return b[sortKey].localeCompare(a[sortKey]);
          }
          return a[sortKey].localeCompare(b[sortKey]);

        })
      }
    }

    return items;
  }

  created(){
    this.modeSwitcher = this.getUserProfile?.config?.config?.production?.defaultSwitch ?? 'groupedSku';
  }

  get canRowClick():boolean
  {
    return this.hasProfileFlag('productionManagement.rowClick');
  }

  goToDetails(item) {
    if(!this.canRowClick){
      return;
    }
    if (event.target?.tagName !== "TD") return;
    if(this.modeSwitcher == 'single'){
       // this.selectedOrderId = item.orderLine.order;
       // this.showOrderProductDialog = true;
      // return;
    }
    this.showProductionDetails(item, false);
  }
  formatDetails(json:string){
    const tJson = JSON.parse(json);
    let ret = [];
    for(const k in tJson){
      ret.push(k + ': ' + tJson[k]);
    }
    return ret.join(', ');
  }
  closeDetails() {
    this.detailsProduction = null;
    delete this.filterObject["p.sku"];
    this.fetchDataWithParams(this.defaultRequestParams);
  }

  formatDate(date: Date) {
    return dayjs(date).format("DD-MM-YYYY");
  }

  get groupedType() {
    return this.modeSwitcher === "groupedSku";
  }

  get getRecords() {
    if (this.modeSwitcher !== 'single') {
      const uniqueSkus = new Map();
      return this.getProductionRecords.reduce((acc, item) => {
        if (!uniqueSkus.has(item.sku)) {
          uniqueSkus.set(item.sku, true);
          acc.push(item);
        }
        return acc;
      }, []);
    }
    return this.getProductionRecords;
  }

  get isShowGroupView() {
    return this.hasProfileFlag('productionManagement.groupedSwitch')
  }

  get getSurfaceSheets() {
    if (this.productionsList && Array.isArray(this.getRecords)) {
      const summary = this.getRecords.reduce((acm, item) => {
        if (item && item.hasOwnProperty("sheets")) return acm + item.sheets;
      }, 0);
      return `(${summary})`;
    }
    return ``;
  }

  get getSurfaceItems() {
    if (this.productionsList && Array.isArray(this.getRecords)) {
      const summary = this.getRecords.reduce((acm, item) => {
        if (item && item.hasOwnProperty("items")) return acm + item.items;
      }, 0);
      return `(${summary})`;
    }
    return ``;
  }

  get getSurfaceSummary() {
    if (this.productionsList && Array.isArray(this.getRecords)) {
      const summary = this.getRecords.reduce((acm, item) => {
        if (item && item.hasOwnProperty("surface")) return acm + item.surface;
      }, 0);
      return `(${Math.round(summary * 100) / 100}m<sup>2</sup>)`;
    }

    return ``;
  }

  //LINK: CatalogAppFrontendPackages/pazion-catalog/src/views/productions/mixins/production-listing.mixin.ts
}
